import axios from 'axios'

export const byLocation = (lat, lng, limit) =>
    axios.get(`users/list_users/0/${limit}`, {lat, lng})
    
export const toggleFollow = (id_user) =>
    axios.get(`users/toggle_follow/${id_user}`)

export const filter = (filter, limit = 20) =>
    axios.get(`users/list_users/0/${limit}?filter=${filter}`)


// WEBPACK FOOTER //
// ./src/utils/users.js